import { Card, Grid, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import { SearchContext } from '../../contexts/SearchContext';
import './index.scss';


export const SearchResultHeaderRow: React.SFC = () => {

    const searchContext = useContext(SearchContext);
    const headerClasses = () => {

        let classString = "result-header-text";

        return classString;
    }


    const showProperty = (propertyName: string) => {
        return searchContext.resultOptions
            .filter(x => x.propertyName === propertyName)[0]
            ?.visible;
    }


    return (

        <Grid item xs={12} >
            <Card
                sx={{ p: 1, mb: 1.5, cursor: "pointer", backgroundColor: "transparent" }}
                elevation={0}
            >
                <Grid container>
                    <Grid item xs={6} container>
                        <Grid item xs={4}>
                            <Typography className={headerClasses()}><strong>Description Level 3</strong></Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography className={headerClasses()}><strong>Level 1</strong></Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography className={headerClasses()}><strong>Level 2</strong></Typography>
                        </Grid>
                    </Grid>

                    <Grid item xs={4} container>

                        {showProperty("vehicleClasses") &&
                            <Grid item xs={3} display={{ xs: 'none', md: 'block' }}>
                                <Typography className={headerClasses()}><strong>Class</strong></Typography>
                            </Grid>
                        }

                        {showProperty("ownedBy") &&
                            <Grid item xs={3} display={{ xs: 'none', md: 'block' }}>
                                <Typography className={headerClasses()}><strong>Owned By</strong></Typography>
                            </Grid>
                        }

                        {showProperty("spareType") &&
                            <Grid item xs={3} display={{ xs: 'none', md: 'block' }}>
                                <Typography className={headerClasses()}><strong>Type</strong></Typography>
                            </Grid>
                        }

                        {showProperty("state") &&
                            <Grid item xs={2} display={{ xs: 'none', md: 'block' }}>
                                <Typography className={headerClasses()}><strong>Status</strong></Typography>
                            </Grid>
                        }

                        {showProperty("quantity") &&
                            <Grid item xs={1} display={{ xs: 'none', md: 'block' }}>
                                <Typography className={headerClasses()}><strong>Total</strong></Typography>
                            </Grid>
                        }
                    </Grid>

                </Grid>

            </Card>

        </Grid>

    );
}